import React, { useContext, useEffect, useState, useRef } from "react";
import FuturesTableContainer from "./components/FuturesTable/FuturesTableContainer";
import {
  BACKGROUND_GRAY,
  BLUE_30,
  BLUE_40,
  GREEN_40,
  GREEN_30
} from "../constants/css.constants";
import ShipmentMonthTables from "./components/ShipmentMonthTables/ShipmentMonthTables";
import TotalBusinessModelContainer from "./components/TotalBusinessModelTable/TotalBusinessModelContainer";
import AtOnceTable from "./components/AtOnceTable/AtOnceTable";
import Button from "@mui/material/Button";
import DistributionTable from "./components/DistributionTable/DistributionTable";
import Box from "@mui/material/Box";
import { useParams } from "react-router";
import { useHistory, useLocation } from "react-router-dom";
import { THREE_PW } from "../routes";
import Typography from "@mui/material/Typography";
import { Dialog } from "@mui/material";
import useQueryParams, { COUNTRY_PARAM, ACCOUNT_PARAM } from "../hooks/useQueryParams";
import { AtOnceProvider } from "../contexts/AtOnceContext";
import DownloadButton from "./components/DownloadButton/DownloadButton";
import { DistributionProvider } from "../contexts/DistributionContext";
import { FuturesProvider } from "../contexts/FuturesContext";
import { SeasonToMonthProvider } from "../contexts/SeasonToMonthContext";
import { FORECAST_URI } from "./components/ShipmentMonthTables/ShipmentMonthTables.constants";
import useClient from "../hooks/useClient";
import { Check, FileDownload } from "@mui/icons-material";
import { ForecastContext } from "../contexts/ForecastContext";
import SaveButton from "./components/SaveButton/SaveButton";
import RevertButton from "./components/RevertButton/RevertButton";
import { DueDateContext } from "../contexts/DueDateContext";
import StyledSpinner from "../components/StyledSpinnner/StyledSpinner";
import useSubmissionDate from "../hooks/useSubmissionDate";
import useEditRights from "../hooks/useEditRights";
import Modal from "../components/Modal/Modal";
import {IGNORE_SUBMISSION_WINDOW, ROUTE_TO_TASK_STATUS_RESPONSE} from "../constants/app.constants";


const tabs = [
  { value: "ap", label: "AP" },
  { value: "fw", label: "FW" },
  { value: "eq", label: "EQ" },
  { value: "tb", label: "TB" },
];

const ShipmentSubmit = () => {
  const { tab } = useParams<{ tab: string }>();
  const { createShipmentSubmitQueryParams, queryParams: qp } = useQueryParams();
  const { pathname, search } = useLocation();
  const { isSubWindowLoading, shipmentMonthDate } = useContext(DueDateContext);
  const { loading, task_status_data } = useContext(ForecastContext);
  const isDataLoading = loading || isSubWindowLoading
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [hasSubmitError, setHasSubmitError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const [existingTab, setExistingTab] = useState(tab);
  const [currentLocation, setCurrentLocation] = useState("");
  const [disableSubmit, setDisableSubmit] = useState(false);
  const { postData } = useClient();
  const { outsideSubmissionDate } = useSubmissionDate();
  const { canEdit } = useEditRights();
  const disabled = (IGNORE_SUBMISSION_WINDOW) ? false : outsideSubmissionDate || !canEdit;

  const curTabRef = useRef<any>(null);
  const currentCountry = qp.get(COUNTRY_PARAM)
  const currentAccount = qp.get(ACCOUNT_PARAM)?.toUpperCase()
  const currentCountryTaskStatuses: any = currentCountry ? task_status_data[currentCountry] : null
  const currentBusinessModel = pathname.split("/")[1].split(/^\w+-/)[1];
  const lookUpBusinessModel = ROUTE_TO_TASK_STATUS_RESPONSE[currentBusinessModel];
  const lookupTaskStatuses = currentCountryTaskStatuses ?
                              (lookUpBusinessModel === "3PP_CONSIGN" || lookUpBusinessModel === "3PP_DROP_SHIP") &&
                              currentAccount ?
                                    currentCountryTaskStatuses[lookUpBusinessModel][currentAccount] :
                                    currentCountryTaskStatuses[lookUpBusinessModel]
                              : null;

  useEffect(() => {
    if (tab !== existingTab) {
      setExistingTab(tab);
    }
  }, [tab]);
  useEffect(() => {
    if (pathname !== currentLocation) {
      setCurrentLocation(pathname);
    }
  });
  const handleChange = (value: string) => {
    const currentLocation = pathname.split("/")[1];
    history.push(`/${currentLocation}/${value}${search}`);
  };

  const hasShipmentMonthsTable = pathname.includes(THREE_PW) && tab !== "tb";
  const handleModalOpen = (open: boolean) => {
    setIsOpen(open);
  };

  const handleSubmit = async () => {
    setDisableSubmit(true);
    const queryParams = createShipmentSubmitQueryParams(tab);
    const result = await postData(
      `${FORECAST_URI}${queryParams}`,
      {},
      (text: string) => {
        setHasSubmitError(true);
        setDisableSubmit(false);
        setErrorMessage(text);
        handleModalOpen(false);
      },
    );
    if (result) {
      setShowSuccess(true);
      if (curTabRef.current) {curTabRef.current.style.backgroundColor=GREEN_40;}
      setTimeout(() => {
        setShowSuccess(false);
        setDisableSubmit(false);
        handleModalOpen(false);
      }, 3000);
    }
  };

  const downloadOrderBook = () => {
    window.open("https://nike.ent.box.com/folder/232046869390");
  };
  const setError = (message: string) => (text: string) => {
    setErrorMessage(text && text.length ? text : message);
    setHasSubmitError(true);
  };

  return isDataLoading || pathname !== currentLocation ? (
    <Box position="absolute" top="50%" left="50%">
      <StyledSpinner />
    </Box>
  ) : (
    <SeasonToMonthProvider date={shipmentMonthDate}>
      <FuturesProvider>
        <DistributionProvider>
          <AtOnceProvider pathname={pathname}>
            <>
              <Modal
                isOpen={isOpen}
                handleYes={handleSubmit}
                disabled={disableSubmit}
                text="Are you sure you want to submit?"
                handleClose={() => handleModalOpen(false)}
              />
              <Dialog open={hasSubmitError}>
                <Typography style={{ padding: "20px" }}>
                  {errorMessage}
                </Typography>
                <Box
                  display="flex"
                  justifyContent="flex-end"
                  margin="0 20px 20px 0"
                >
                  <Button
                    onClick={() => {
                      setHasSubmitError(false);
                      setErrorMessage("");
                    }}
                    style={{
                      width: "100px",
                      height: "50px",
                      backgroundColor: GREEN_40,
                    }}
                  >
                    OK
                  </Button>
                </Box>
              </Dialog>
              <Box
                marginBottom="50px"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Box>
                  {tabs.map((buttonTab) => (
                    <Button
                      key={buttonTab.value}
                      onClick={() => handleChange(buttonTab.value)}
                      variant="contained"
                      size="large"
                      style={{
                        marginRight: "15px",
                        width: "180px",
                        backgroundColor:
                            (lookupTaskStatuses && lookupTaskStatuses.hasOwnProperty(buttonTab.label) &&
                                lookupTaskStatuses[buttonTab.label] === true) ?
                                buttonTab.value === tab ? GREEN_40 : GREEN_30 :
                                buttonTab.value === tab ? BLUE_40 : BLUE_30,
                        color: "#fff",
                        borderRadius: "0",
                      }}
                      ref={buttonTab.value === tab ? curTabRef : null}
                    >
                      {buttonTab.label}
                    </Button>
                  ))}
                </Box>
                <Button
                  style={{ marginRight: "150px", padding: "15px 8px" }}
                  onClick={downloadOrderBook}
                >
                  <FileDownload style={{ transform: "scale(1.5)" }} />
                </Button>
              </Box>
              <Typography variant="h5" marginBottom="5px">
                Futures
              </Typography>
              {hasShipmentMonthsTable && <ShipmentMonthTables />}
              <FuturesTableContainer />
              <DistributionTable />
              <AtOnceTable />
              <TotalBusinessModelContainer />
              <Box display="flex">
                {tab !== "tb" && (
                  <>
                    <RevertButton
                      queryParams={createShipmentSubmitQueryParams(tab)}
                      setError={setError("Could not revert. Please try again.")}
                      tabRef={curTabRef}
                    />
                    <SaveButton
                      queryParams={createShipmentSubmitQueryParams(tab)}
                      setError={setError(
                        "Could not save. Please try again later.",
                      )}
                      tabRef={curTabRef}
                    />
                  </>
                )}
                <DownloadButton
                  tab={tab.toUpperCase()}
                  pathname={pathname}
                  country={qp.get(COUNTRY_PARAM) ?? ""}
                />
                {tab == "tb" && (
                  <>
                    <Button
                      style={{
                        color: "#fff",
                        fontSize: "large",
                        height: "75px",
                        backgroundColor: disabled ? BACKGROUND_GRAY : GREEN_40,
                        margin: "40px 20px 0 0",
                        whiteSpace: "nowrap",
                      }}
                      variant="contained"
                      onClick={() => handleModalOpen(true)}
                      size="large"
                      disabled={disabled}
                    >
                      Submit Forecast
                    </Button>
                    <Box display="flex" alignItems="center" marginTop="20px">
                      {showSuccess && <Check color={"success"} />}
                    </Box>
                  </>
                )}
              </Box>
            </>
          </AtOnceProvider>
        </DistributionProvider>
      </FuturesProvider>
    </SeasonToMonthProvider>
  );
};
export default ShipmentSubmit;
